import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";

export function CategoriesPage() {
    return (
        <div className="space-y-6">
            <h2 className="text-3xl font-bold tracking-tight">Categories</h2>
            <Card>
                <CardHeader>
                    <CardTitle>Category Management</CardTitle>
                </CardHeader>
                <CardContent>
                    <p className="text-muted-foreground">Category management interface will be implemented here.</p>
                </CardContent>
            </Card>
        </div>
    );
}
